import { IsNotEmpty, IsOptional, IsInt, IsObject, IsArray, ValidateNested, IsString } from 'class-validator';

import { TaxonomyValues } from '../../taxonomy';
import { NomenclatureUnitCompositionRequest } from '../../nomenclature/nomenclature-unit-composition.request';

export class OrderPositionCompositionGetRequest {
    /**
     * Optional: the frontend omits it when building a composition for a NEW position (no saved state).
     * Mirrors PHP OrderController::actionGetOrderPositionComposition where orderPositionId may be missing.
     */
    @IsOptional()
    @IsInt()
    public orderPositionId?: number;

    @IsString()
    @IsNotEmpty()
    public nomPositionUuid: string;

    @IsOptional()
    @IsObject()
    public values?: TaxonomyValues;

    @IsOptional()
    @IsArray()
    @ValidateNested({ each: true })
    public composition?: NomenclatureUnitCompositionRequest[];

    constructor(data?: Partial<OrderPositionCompositionGetRequest>) {
        this.orderPositionId = data?.orderPositionId;
        this.nomPositionUuid = data?.nomPositionUuid;
        this.values = data?.values;
        this.composition = Array.isArray(data?.composition)
            ? data.composition.map(item => new NomenclatureUnitCompositionRequest(item))
            : data?.composition;
    }
}
